import React from 'react'
import PropTypes from 'prop-types'
import Form from 'pages/widgets/form-actions/edit'
import PageTemplate from 'components/page-template'

const Page = ({ params: { id } }) => (
  <PageTemplate
    title='Update a Mentions Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form id={id} experiencePlatform='twitter' experienceType='mentions' />
  </PageTemplate>
)

Page.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string })
}

export default Page



// WEBPACK FOOTER //
// ./src/pages/widgets/mentions/edit/index.js